import React, { createContext, useContext, ReactNode } from 'react';

interface TrackerUnreadContextType {
  refetchUnreadCount: () => void;
}

const TrackerUnreadContext = createContext<TrackerUnreadContextType | undefined>(undefined);

interface TrackerUnreadProviderProps {
  children: ReactNode;
  refetchUnreadCount: () => void;
}

/**
 * TrackerUnreadProvider - Provides refetch function for tracker unread count
 * Allows child components to trigger badge updates after marking tasks as read
 */
export const TrackerUnreadProvider: React.FC<TrackerUnreadProviderProps> = ({
  children,
  refetchUnreadCount
}) => {
  return (
    <TrackerUnreadContext.Provider value={{ refetchUnreadCount }}>
      {children}
    </TrackerUnreadContext.Provider>
  );
};

/**
 * Hook to access tracker unread context
 * @returns refetchUnreadCount function to trigger badge updates
 */
export const useTrackerUnreadContext = (): TrackerUnreadContextType => {
  const context = useContext(TrackerUnreadContext);
  if (!context) {
    // Return no-op function if context is not available (outside provider)
    return {
      refetchUnreadCount: () => {
        console.warn('[Tracker] refetchUnreadCount called outside TrackerUnreadProvider');
      }
    };
  }
  return context;
};

export default TrackerUnreadContext;
